import React, { useEffect, useState } from "react";
import { fetchCategories } from "../../api/CategoryApi";
import { Link } from "react-router-dom";

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories()
      .then((data) => {
        setCategories(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );

  return (
    <section className="section">
      <div className="section-header">
        <h2 className="section-title">Categories</h2>
        <Link to="/categories" className="see-more">
          See more
        </Link>
      </div>
      <div className="categories-grid">
        {Array.isArray(categories) && categories.length > 0 ? (
          categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.id}
              to={`/apps/category/${cat.slug}`}
              className="category-card"
              style={{ textDecoration: "none" }}
            >
              <div
                className="category-icon"
                style={{
                  backgroundImage: `url(${cat.icon_url})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  textDecoration: "none",
                }}
              ></div>
              <div className="category-name" style={{ textDecoration: "none" }}>
                {cat.name}
              </div>
            </Link>
          ))
        ) : (
          <p>No categories found.</p>
        )}
      </div>
    </section>
  );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // full page center
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// Add global keyframes for spinner
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`,
  styleSheet.cssRules.length
);

export default Categories;
